import * as sdk_common from '@journeyapps-labs/common-sdk';
import {
  ExtractNativeResponseFromNetworkResponse,
  NetworkClientParams,
  NetworkResponse,
  RequestParams
} from '@journeyapps-labs/common-sdk';

export class AdminNetworkClient implements sdk_common.WebNetworkClient {
  private client: sdk_common.WebNetworkClient;
  private options?: sdk_common.NetworkClientParams<Response>;

  constructor(options?: sdk_common.NetworkClientParams<Response>) {
    this.options = options;
    this.client = sdk_common.createWebNetworkClient(options);
  }

  augment = <T extends sdk_common.WebNetworkClient>(options: Partial<NetworkClientParams>) =>
    new AdminNetworkClient({ ...options, ...(this.options || {}) }) as unknown as T;

  request = async (
    url: string,
    params: RequestParams<ExtractNativeResponseFromNetworkResponse<NetworkResponse<any>>, any>
  ): Promise<NetworkResponse<any>> => {
    const res = await this.client.request(url, params);
    if (res.response.status === 401) {
      window.location.reload();
    }

    return res;
  };
}
